import { Outlet } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { PageContent, PageHeader } from '@nucleus-commerce/admin-kit/layout';

import { CatalogSetupTabs } from '../components/catalog-setup-tabs';

/** Title and tabs shared by the catalog setup screens; each tab renders its own toolbar. */
export function CatalogSetupLayout() {
  const { t } = useTranslation('dictionary');
  return (
    <PageContent>
      <PageHeader title={t('setup.title')} description={t('setup.description')} />
      <CatalogSetupTabs />
      <Outlet />
    </PageContent>
  );
}
